export enum UnitType {
  Origin = 'Platform Units',
  External = 'Other Units',
}
